import { RoleProps } from "modules/auth/role/store/actionType";

/* Auth Actions */
export enum actionTypes {
  //fetch users
  FETCH_USERS_REQUEST = "FETCH_USERS_REQUEST",
  FETCH_USERS_SUCCESS = "FETCH_USERS_SUCCESS",
  FETCH_USERS_FAIL = "FETCH_USERS_FAIL",
  //create user
  CREATE_USER_REQUEST = "CREATE_USER_REQUEST",
  CREATE_USER_SUCCESS = "CREATE_USER_SUCCESS",
  CREATE_USER_FAIL = "CREATE_USER_FAIL",
  //update users
  UPDATE_USER_REQUEST = "UPDATE_USER_REQUEST",
  UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS",
  UPDATE_USER_FAIL = "UPDATE_USER_FAIL",
  SAVE_CREATE_USER_FORM_DATA = "SAVE_CREATE_USER_FORM_DATA",
  RESET_CREATE_USER_STATE = "RESET_CREATE_USERSTATE",
  UPDATE_CREATE_USER_FORM_ERROR = "UPDATE_CREATE_USER_FORM_ERROR",
  CHECK_FOR_EXISTING_USER_BY_MOBILE_REQUEST = "CHECK_FOR_EXISTING_USER_BY_MOBILE_REQUEST",
  CHECK_FOR_EXISTING_USER_BY_MOBILE_SUCCESS = "CHECK_FOR_EXISTING_USER_BY_MOBILE_SUCCESS",
  CHECK_FOR_EXISTING_USER_BY_MOBILE_FAIL = "CHECK_FOR_EXISTING_USER_BY_MOBILE_FAIL",
  CHECK_FOR_EXISTING_USER_BY_EMAIL_REQUEST = "CHECK_FOR_EXISTING_USER_BY_EMAIL_REQUEST",
  CHECK_FOR_EXISTING_USER_BY_EMAIL_SUCCESS = "CHECK_FOR_EXISTING_USER_BY_EMAIL_SUCCESS",
  CHECK_FOR_EXISTING_USER_BY_EMAIL_FAIL = "CHECK_FOR_EXISTING_USER_BY_EMAIL_FAIL",
  //change user name
  CHANGE_USER_NAME_REQUEST = "CHANGE_USER_NAME_REQUEST",
  CHANGE_USER_NAME_SUCCESS = "CHANGE_USER_NAME_SUCCESS",
  CHANGE_USER_NAME_FAIL = "CHANGE_USER_NAME_FAIL",
  //change user password
  CHANGE_USER_PASSWORD_REQUEST = "CHANGE_USER_PASSWORD_REQUEST",
  CHANGE_USER_PASSWORD_SUCCESS = "CHANGE_USER_PASSWORD_SUCCESS",
  CHANGE_USER_PASSWORD_FAIL = "CHANGE_USER_PASSWORD_FAIL",
  //reset user password
  RESET_USER_PASSWORD_REQUEST = "RESET_USER_PASSWORD_REQUEST",
  RESET_USER_PASSWORD_SUCCESS = "RESET_USER_PASSWORD_SUCCESS",
  RESET_USER_PASSWORD_FAIL = "RESET_USER_PASSWORD_FAIL",
  //change user detail(email or mobile no)
  CHANGE_USER_DETAIL_REQUEST = "CHANGE_USER_DETAIL_REQUEST",
  CHANGE_USER_DETAIL_SUCCESS = "CHANGE_USER_DETAIL_SUCCESS",
  CHANGE_USER_DETAIL_FAIL = "CHANGE_USER_DETAIL_FAIL",

  //update user roles
  UPDATE_USER_ROLES_REQUEST = "UPDATE_USER_ROLES_REQUEST",
  UPDATE_USER_ROLES_SUCCESS = "UPDATE_USER_ROLES_SUCCESS",
  UPDATE_USER_ROLES_FAIL = "UPDATE_USER_ROLES_FAIL",

}

export enum stateStatusType {
  SUCCESS = "SUCCESS",
  FAILED = "FAILED",
}
export interface GenericAuthStateProps {
  isLoading: boolean;
  status: stateStatusType | null;
  error: string | null;
}
export interface CreateUserProps {
  [x: string]: any;
  name: string;
  mobile_no: string;
  email?: string;
  password: string;
  role_ids: string[];
  confirm_password?: string;
  state_updated_at?: string | null;
}

export interface CreateUserFormError {
  name: string | null;
  mobile_no: string | null;
  email?: string | null;
  password: string | null;
  confirm_password: string | null;
  emailOrMobile: string | null;
  status?: string | null;
  role_ids?: string | null;
}

export interface UserPayloadProps {
  user: CreateUserProps;
}

export interface UserProps {
  email: string;
  mobile_no: string;
  status: string;
  id: string;
  user_identifier: string;
  name: string;
  created_at: string;
  updated_at: string;
  roles: RoleProps[];
}
export interface UpdateSingleAuthDataInput {
  password: string;
  field: string;
  value: string;
}

export interface UpdateSingleAuthDataInputError {
  password?: string;
  field?: string;
  value?: string;
}
export interface UpdatePasswordInput {
  password: string;
  confirm_password: string;
  current_password: string;
  user_id: string;
}

export interface UpdatePasswordInputError {
  password?: string;
  confirm_password?: string;
  current_password?: string;
}
export interface ResetPasswordInput {
  user_id: string;
  password: string;
  confirm_password: string;
}

export interface ResetPasswordInputError {
   password?: string;
  confirm_password?: string;
}
export interface AuthUserProp extends UserProps{
  authorities:[string]
  isSuperAdmin:boolean
}

//fetch
export interface FetchUsersRequestAction {
  type: actionTypes.FETCH_USERS_REQUEST;
}

export interface FetchUsersSuccessAction {
  type: actionTypes.FETCH_USERS_SUCCESS;
  payload: UserProps[];
}

export interface FetchUsersFailureAction {
  type: actionTypes.FETCH_USERS_FAIL;
  payload: string;
}

//create user
export interface CreateUserRequestAction {
  type: actionTypes.CREATE_USER_REQUEST;
}
export interface CreateUserSuccessAction {
  type: actionTypes.CREATE_USER_SUCCESS;
  payload:UserProps
}

export interface CreateUserFailAction {
  type: actionTypes.CREATE_USER_FAIL;
  payload: string;
}

//update user

export interface UpdateUserRequestAction {
  type: actionTypes.UPDATE_USER_REQUEST;
}
export interface UpdateUserSuccessAction {
  type: actionTypes.UPDATE_USER_SUCCESS;
  payload: UserProps;
}

export interface UpdateUserFailAction {
  type: actionTypes.UPDATE_USER_FAIL;
  payload: string;
}

//update user roles
export interface UpdateUserRolesRequestAction {
  type: actionTypes.UPDATE_USER_ROLES_REQUEST;
}
export interface UpdateUserRolesSuccessAction {
  type: actionTypes.UPDATE_USER_ROLES_SUCCESS;
  payload: UserProps;
}

export interface UpdateUserRolesFailAction {
  type: actionTypes.UPDATE_USER_ROLES_FAIL;
  payload: string;
}

//SaveCREATE_USERFormData
export interface SaveCreateUserFormDataAction {
  type: actionTypes.SAVE_CREATE_USER_FORM_DATA;
  payload: CreateUserProps;
}

//ResetState
export interface ResetCreateUserStateAction {
  type: actionTypes.RESET_CREATE_USER_STATE;
}

//ResetState
export interface UpdateCreateUserFormErrorAction {
  type: actionTypes.UPDATE_CREATE_USER_FORM_ERROR;
  payload: CreateUserFormError;
}

//CheckForExistingUserByMobile
export interface CheckForExistingUserByMobileRequestAction {
  type: actionTypes.CHECK_FOR_EXISTING_USER_BY_MOBILE_REQUEST;
}
export interface CheckForExistingUserByMobileSuccessAction {
  type: actionTypes.CHECK_FOR_EXISTING_USER_BY_MOBILE_SUCCESS;
}

export interface CheckForExistingUserByMobileFailAction {
  type: actionTypes.CHECK_FOR_EXISTING_USER_BY_MOBILE_FAIL;
  payload: string;
}

//CheckForExistingUserByEmail
export interface CheckForExistingUserByEmailRequestAction {
  type: actionTypes.CHECK_FOR_EXISTING_USER_BY_EMAIL_REQUEST;
}
export interface CheckForExistingUserByEmailSuccessAction {
  type: actionTypes.CHECK_FOR_EXISTING_USER_BY_EMAIL_SUCCESS;
}

export interface CheckForExistingUserByEmailFailAction {
  type: actionTypes.CHECK_FOR_EXISTING_USER_BY_EMAIL_FAIL;
  payload: string;
}
//change user name
export interface ChangeUserNameRequestAction {
  type: actionTypes.CHANGE_USER_NAME_REQUEST;
}
export interface ChangeUserNameSuccessAction {
  type: actionTypes.CHANGE_USER_NAME_SUCCESS;
  payload: UserProps;
}

export interface ChangeUserNameFailAction {
  type: actionTypes.CHANGE_USER_NAME_FAIL;
  payload: string;
}
//change user password
export interface ChangeUserPasswordRequestAction {
  type: actionTypes.CHANGE_USER_PASSWORD_REQUEST;
}
export interface ChangeUserPasswordSuccessAction {
  type: actionTypes.CHANGE_USER_PASSWORD_SUCCESS;
  payload: UserProps;
}

export interface ChangeUserPasswordFailAction {
  type: actionTypes.CHANGE_USER_PASSWORD_FAIL;
  payload: string;
}
//reset user password
export interface ResetUserPasswordRequestAction {
  type: actionTypes.RESET_USER_PASSWORD_REQUEST;
}
export interface ResetUserPasswordSuccessAction {
  type: actionTypes.RESET_USER_PASSWORD_SUCCESS;
  payload: UserProps;
}

export interface ResetUserPasswordFailAction {
  type: actionTypes.RESET_USER_PASSWORD_FAIL;
  payload: string;
}
//change user detail
export interface ChangeUserDeatilRequestAction {
  type: actionTypes.CHANGE_USER_DETAIL_REQUEST;
}
export interface ChangeUserDeatilSuccessAction {
  type: actionTypes.CHANGE_USER_DETAIL_SUCCESS;
  payload: UserProps;
}

export interface ChangeUserDeatilFailAction {
  type: actionTypes.CHANGE_USER_DETAIL_FAIL;
  payload: string;
}

//AuthActions
export type AuthActions =
  | FetchUsersRequestAction
  | FetchUsersSuccessAction
  | FetchUsersFailureAction
  | CreateUserRequestAction
  | CreateUserSuccessAction
  | CreateUserFailAction
  | UpdateUserRequestAction
  | UpdateUserSuccessAction
  | UpdateUserFailAction
  | UpdateUserRolesRequestAction
  | UpdateUserRolesSuccessAction
  | UpdateUserRolesFailAction
  | SaveCreateUserFormDataAction
  | ResetCreateUserStateAction
  | UpdateCreateUserFormErrorAction
  | CheckForExistingUserByMobileRequestAction
  | CheckForExistingUserByMobileSuccessAction
  | CheckForExistingUserByMobileFailAction
  | CheckForExistingUserByEmailRequestAction
  | CheckForExistingUserByEmailSuccessAction
  | CheckForExistingUserByEmailFailAction
  | ChangeUserNameRequestAction
  | ChangeUserNameSuccessAction
  | ChangeUserNameFailAction
  | ChangeUserPasswordRequestAction
  | ChangeUserPasswordSuccessAction
  | ChangeUserPasswordFailAction
  | ResetUserPasswordRequestAction
  | ResetUserPasswordSuccessAction
  | ResetUserPasswordFailAction
  | ChangeUserDeatilRequestAction
  | ChangeUserDeatilSuccessAction
  | ChangeUserDeatilFailAction;
